import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/global.css'
import './styles/admin.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Unregister ALL old service workers and clear caches
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const reg of registrations) {
      reg.unregister();
    }
  });
  caches.keys().then((cacheNames) => {
    return Promise.all(
      cacheNames.map((cache) => caches.delete(cache))
    );
  });

  // Register fresh service worker after clearing
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('SW Registered:', reg.scope);
      })
      .catch((err) => console.log('SW Reg Failed:', err));
  });
}

// Detect PWA mode
if ((window.navigator as any).standalone === true || window.matchMedia('(display-mode: standalone)').matches) {
  document.documentElement.classList.add('pwa-mode');
}

// Handle install prompt
let deferredPrompt: any;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new CustomEvent('pwa-installable', { detail: { prompt: deferredPrompt } }));
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  window.dispatchEvent(new CustomEvent('pwa-installed'));
});
